import { render, staticRenderFns } from "./best-start-modal.component.vue?vue&type=template&id=54127ffe&scoped=true"
import script from "./best-start-modal.component.vue?vue&type=script&lang=js"
export * from "./best-start-modal.component.vue?vue&type=script&lang=js"
import style0 from "./best-start-modal.component.vue?vue&type=style&index=0&id=54127ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54127ffe",
  null
  
)

export default component.exports